import { z } from "zod";

/**
 * Card template message
 */
export const CardTemplateMessageSchema = z.object({
  type: z.literal("card"),
  name: z.string(),
  /**
   * Runtime flag (NEX-4407), stamped by the chat loop from the deployment's
   * `cardEndsTurn` setting — never stored on the template itself. A card send
   * carrying it ends the agent's turn when it is the LAST tool call of its
   * assistant message.
   */
  endsTurn: z.boolean().optional()
});
